import { Modifier } from "@/dto/modifier";
import { SpecialInstructions } from "./specialInstructions";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { modifierDisplay } from "@/utils/modifierDisplayUtil";

export interface CartItemModifierListProps {
  modifiers: Modifier[];
  specialInstructions?: string;
}

export const CartItemModifierList = ({
  modifiers,
  specialInstructions,
}: CartItemModifierListProps) => {
  return (
    <div
      className="max-w-[80%]"
      data-testid={applyDataTestId(pom.scanToOrder.cartItemModifierList)}
    >
      {modifiers.length > 0 && (
        <p className="text-[15px] text-[#727272] text-left">
          {modifierDisplay(modifiers)}
        </p>
      )}
      <SpecialInstructions specialInstructions={specialInstructions} />
    </div>
  );
};
